import{e as h,m as n}from"./chunk-HBP5N4FR.js";var c,l=h(()=>{n();c=(t,g=4)=>`${t.substring(0,Math.floor(t.length/g))}...${t.substring(t.length-Math.ceil(t.length/g))}`});export{c as a,l as b};
//# sourceMappingURL=chunk-NLU2B6MT.js.map
